const accordionElements = document.querySelectorAll<HTMLElement>(
  '.content-block.content-block--faq .accordion',
);

accordionElements.forEach((accordionElement) => {
  const accordionTriggerElement =
    accordionElement.querySelector<HTMLButtonElement>('.accordion__trigger');
  if (!accordionTriggerElement) return;

  accordionTriggerElement.addEventListener('click', () => {
    accordionElements.forEach(
      (_accordionElement) =>
        _accordionElement !== accordionElement &&
        _accordionElement.classList.remove('accordion--open'),
    );
    accordionElement.classList.toggle('accordion--open');
  });
});
